import {
  FETCH_CARGO_COMPANIES_PENDING,
  FETCH_CARGO_COMPANIES_REJECTED,
  FETCH_CARGO_COMPANIES_FULFILLED
} from "../constants/cargoCompanies";

const initialState = {
  cargoCompanies: [],
  loaded: false,
  pending: false,
  error: null
};

export const cargoCompanies = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CARGO_COMPANIES_PENDING: 
      return {
        ...state,
        pending: true,
        error: null
      };

    case FETCH_CARGO_COMPANIES_FULFILLED: 
      return {
        ...state,
        cargoCompanies: action.data.results,
        loaded: true,
        pending: false,
        error: null
      };
    
    case FETCH_CARGO_COMPANIES_REJECTED: 
      return {
        ...state,
        pending: false,
        error: action.error
      };

    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/cargoCompanies.js